import { Reducer } from 'redux'

export type ErrorState = {
  context?: string
  message?: string
  error?: string
}

const SET_ERROR = 'SET_ERROR'
const CLEAR_ERROR = 'CLEAR_ERROR'

export function setError(
  context: string,
  error?: Error | string,
  message?: string
) {
  return {
    type: SET_ERROR,
    payload: {
      context,
      message:
        message ||
        (error instanceof Error ? error.message : String(error || '')),
      error: error instanceof Error ? error.message : String(error || ''),
    },
  }
}

export function clearError() {
  return { type: CLEAR_ERROR }
}

const initialState: ErrorState = {}

export const reducer: Reducer<ErrorState> = (
  state = initialState,
  action
): ErrorState => {
  switch (action.type) {
    case SET_ERROR:
      return {
        context: action.payload.context,
        message: action.payload.message,
        error: action.payload.error,
      }
    case CLEAR_ERROR:
      return initialState
    default:
      return state
  }
}
